import React, {memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/product-summary"
import connect from "./connect"
import {TextModel} from "../../models/Text"

export interface PriceProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    tooltipTitle: string
    saleBasePrice?: string | null
    wasBasePrice?: string | null
    basePrice: string
    bundlePrice: string
    wasBundlePrice?: string | null
    saleBundlePrice?: string | null
    shadePrice: string
    wasShadePrice?: string | null
    saleShadePrice?: string | null
    text: TextModel
    basesHasSale: boolean
    shadesHasSale: boolean
    bundlePriceAriaLabel: string
    bundleBasePriceAriaLabel: string
    bundleShadesPriceAriaLabel: string
    brandedMarkdownSalePrice: boolean
    bundlePriceLabel: string
}

export const BundlePrice = memo(
    ({
        templating,
        tooltipTitle,
        shadePrice,
        wasShadePrice,
        saleShadePrice,
        bundlePrice,
        wasBundlePrice,
        saleBundlePrice,
        basePrice,
        wasBasePrice,
        saleBasePrice,
        text,
        basesHasSale,
        shadesHasSale,
        bundlePriceAriaLabel,
        bundleBasePriceAriaLabel,
        bundleShadesPriceAriaLabel,
        brandedMarkdownSalePrice,
        bundlePriceLabel,
    }: PriceProps) => {
        const ComponentName = useTemplatedComponent(templating, MANIFEST)
        const wasBundlePriceText = `${text.price.was} ${wasBundlePrice}`
        const saleBundlePriceText = `${text.price.now} ${saleBundlePrice}`
        const wasShadePriceText = `${text.price.was} ${wasShadePrice}`
        const saleShadePriceText = `${text.price.now} ${saleShadePrice}`
        const wasBasePriceText = `${text.price.was} ${wasBasePrice}`
        const saleBasePriceText = `${text.price.now} ${saleBasePrice}`
        const bundleHasSale = basesHasSale || shadesHasSale

        return (
            <ComponentName
                tooltipTitle={tooltipTitle}
                shadePrice={shadePrice}
                saleShadePrice={saleShadePrice}
                bundlePrice={bundlePrice}
                saleBundlePrice={saleBundlePrice}
                basePrice={basePrice}
                saleBasePrice={saleBasePrice}
                text={text}
                basesHasSale={basesHasSale}
                shadesHasSale={shadesHasSale}
                bundlePriceAriaLabel={bundlePriceAriaLabel}
                bundleBasePriceAriaLabel={bundleBasePriceAriaLabel}
                bundleShadesPriceAriaLabel={bundleShadesPriceAriaLabel}
                brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                wasBundlePriceText={wasBundlePriceText}
                saleBundlePriceText={saleBundlePriceText}
                wasShadePriceText={wasShadePriceText}
                saleShadePriceText={saleShadePriceText}
                wasBasePriceText={wasBasePriceText}
                saleBasePriceText={saleBasePriceText}
                bundleHasSale={bundleHasSale}
                bundlePriceLabel={bundlePriceLabel}
            />
        )
    },
)
BundlePrice.displayName = "BundlePrice"

export default connect(BundlePrice)
